/**
 * Procedure Categories and Procedures for M.Ch. in Pediatric Surgery students
 * Extracted with strict evidence from official NMC PDF (Page 13-15: "Psychomotor domain - PERFORM THE FOLLOWING PROCEDURES INDEPENDENTLY")
 */
export const PEDIATRIC_SURGERY_PROCEDURES = {
  "Neonatal & Pediatric Emergency, Airway & Vascular Access Procedures": [
    "Neonatal & Pediatric Central Venous Access (PICC, Chemoport, Hickman Catheter, Umbilical Vein)",
    "Arterial Line Placement & Peripheral Vascular Access",
    "Tracheostomy, Cricothyroidotomy & Diagnostic Laryngoscopy / Bronchoscopy / Esophagoscopy",
    "Intercostal Chest Tube Insertion (ICTD) & Diagnostic Thoracoscopy",
    "Basic & Advanced Neonatal / Pediatric Resuscitation (NALS / PALS)",
    "Peritoneal Dialysis Catheter Insertion",
  ],
  "Pediatric Head, Neck, Thoracic & Reconstructive Surgeries": [
    "Repair of Cleft Lip & Cleft Palate",
    "Sistrunk's Procedure for Thyroglossal Cyst & Excision of Branchial Remnants",
    "Release of Ankyloglossia (Tongue Tie) & Ranula Marsupialization",
    "Sternomastoid Muscle Release for Torticollis",
    "Primary Repair & Diversion for Tracheoesophageal Fistula (TEF / Esophageal Atresia)",
    "Repair of Congenital Diaphragmatic Hernia (Bochdalek & Morgagni) & Diaphragmatic Eventration",
    "VP Shunt Placement, External Ventricular Drain (EVD) & Spina Bifida Repair",
  ],
  "Pediatric Abdominal, Genitourinary & Oncological Surgeries": [
    "Pyloromyotomy (Ramstedt Procedure for HPS) & Gastrostomy",
    "Ladd's Procedure for Midgut Malrotation & Surgery for Intestinal Atresia / Meconium Ileus",
    "Appendectomy, Bowel Resection & Anastomosis, Colostomy & Ileostomy Creation / Reversal",
    "Anoplasty & Pull-Through Procedures for Anorectal Malformations & Hirschsprung Disease",
    "Herniotomy for Inguinal Hernia, Hydrocele, Umbilical Hernia & Orchidopexy for Undescended Testis",
    "Hypospadias Repair, Urethral Fistula Repair & Circumcision / Preputioplasty",
    "Nephrectomy, Pyeloplasty, Ureteric Reimplantation & Cystoscopy / PUV Ablation",
    "Pediatric Surgical Oncology (Resection of Wilms Tumor, Neuroblastoma, Hepatoblastoma, Teratoma)",
  ],
};

export const PEDIATRIC_SURGERY_CATEGORIES = Object.keys(PEDIATRIC_SURGERY_PROCEDURES);

export const isMChInPediatricSurgeryDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    d.includes("pediatric surgery") ||
    d.includes("paediatric surgery")
  );
};
